import { AfterViewInit, Directive, ElementRef, Input } from '@angular/core';

@Directive({
  selector: '[xs-auto-focus]',
})
export class AutoFocusDirective implements AfterViewInit {
  @Input() setFocus: boolean = true;

  constructor(private elRef: ElementRef) {}

  ngAfterViewInit(): void {
    if (this.setFocus) {
      this.elRef.nativeElement.focus();
    }
  }
}
